module.exports = {"designations":["Executive Leadership","Human Resource","Software Engineer","Intern","Admin","Office Boy","Sales Executive","Business Analyst","Team Lead","Project Manager","Quality Assurance Engineer","Designer (UI/UX)","Marketing Specialist","Customer Support","Technical Lead"]}


//////////////////
// WEBPACK FOOTER
// ./src/components/data/UserProfileData/designations.json
// module id = Gq4s
// module chunks = 1